import React from "react";

const clientId = Math.random().toString(20).slice(2);
export const VoterClientId = React.createContext(clientId);
